@if (confidenceKey(); as confidenceKey) {
  <p-tag
    [value]="confidenceKey | transloco"
    [severity]="confidenceSeverity()"
    icon="pi pi-sparkles"
    [attr.data-testid]="'suggestion-tag-' + attributeDirectusId()"
  />
}
@if (reviewRequired()) {
  <p-tag
    [value]="'provider.templates.suggestions.tag.reviewRequired' | transloco"
    severity="warn"
    icon="pi pi-exclamation-circle"
    [attr.data-testid]="'suggestion-review-required-' + attributeDirectusId()"
  />
}
@if (clarification()) {
  <p-tag
    [value]="'provider.templates.suggestions.clarification.tag' | transloco"
    severity="warn"
    icon="pi pi-question-circle"
    [pTooltip]="clarificationNote()"
    tooltipPosition="top"
    [attr.data-testid]="'suggestion-clarification-' + attributeDirectusId()"
  />
}
